if (window.MinimogTheme && window.MinimogLibs) {
  class MFooter extends HTMLElement {
    constructor() {
      super();
      this.init();
      this.setupNewsletterValidation(); // :white_tick: Added for .com check
    }
    init() {
      const mobileAccordion = this.querySelector(".m-footer--accordion");
      const mobileStickyBar = document.querySelector(".m-mobile-sticky-bar");
      if (mobileAccordion) {
        if (MinimogTheme.config.mqlMobile) {
          this.acc = new MinimogLibs.Accordion(mobileAccordion, { presetContentHeight: true, onload: true });
        }
        document.addEventListener("matchMobile", () => {
          this.acc = new MinimogLibs.Accordion(mobileAccordion, { presetContentHeight: true, onload: true });
        });
      }
      if (mobileStickyBar) {
        document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${mobileStickyBar.offsetHeight}px`);
        document.addEventListener("matchMobile", () => {
          document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${mobileStickyBar.offsetHeight}px`);
        });
        document.addEventListener("unmatchMobile", () => {
          document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${mobileStickyBar.offsetHeight}px`);
        });
      }
    }
    // :white_tick: This will validate only .com emails inside the footer
    setupNewsletterValidation() {
      const forms = this.querySelectorAll("form");
      forms.forEach((form) => {
        form.addEventListener(
          "submit",
          function (event) {
            const emailInput = form.querySelector("input[type='email']");
            if (emailInput) {
              const emailValue = emailInput.value.trim().toLowerCase();
              if (!/^[^@\s]+@[^@\s]+\.com$/i.test(emailValue)) {
                event.preventDefault();
                event.stopImmediatePropagation();
                alert("Please enter a valid email ending with .com");
                emailInput.focus();
                return false;
              }
            }
          },
          true
        );
      });
    }
  }
  customElements.define("m-footer", MFooter);
}